@if (breakpointService.isDesktop()) {
    <section class="location-info" [id]="getElementId(0)">
        <div class="location-info__content location-info__row">
            <div class="location-info__text location-info__col location-info__col--full">
                <div class="location-info__row">
                    <h2 class="location-info__title">
                        {{ 'TRIP_PLANNER.ABOUT' | translate: {location: name | titlecase} }}
                    </h2>
                    <div class="f-row">
                        <app-weather-renderer
                                [isFetching]="isFetching"
                                [weather]="wheather"
                                [wrapperClass]="['trip-weather']"
                        ></app-weather-renderer>
                    </div>
                </div>

                <app-text-ellipsis
                        style="display: block; margin-top: 35px"
                        [short]="itineraryItem?.shortDescription"
                        [long]="itineraryItem.description"
                        [extra]="itineraryItem.extraDescription"
                        [isSmallText]="true"
                ></app-text-ellipsis>
            </div>
            <div class="location-info__gallery location-info__col">
                <app-gallery
                        [isTripPlannerPage]="true"
                        [isCityPage]="true"
                        [disablePagination]="true"
                        [items]="attractions"
                ></app-gallery>
            </div>
        </div>
        <div class="location-info__footer"></div>
    </section>
    <section class="location-info" [id]="getElementId(1)">
        <div class="location-info__content">
            <app-booking-banner
                    [countryName]="countryName"
                    [cityName]="name"
            ></app-booking-banner>
            <app-hotels-booking-container
                    [itineraryIndex]="cityInfoIndex"
                    [city]="packages.length ? itineraryItem : null"
                    [country]="{id: null, countryName: countryName}"
                    [showInfoBlueLabel]="true"
            ></app-hotels-booking-container>
        </div>
        <div class="location-info__footer"></div>
    </section>
    <section class="location-info" [id]="getElementId(2)">
        <div class="location-info__header location-info__header--col">
            <div class="title-box title-box--with-icon">
                <h2 class="title-box__title">
                    {{ 'VIATOR.LANDMARKS_AND_ACTIVITIES_IN' | translate: {city: name | replaceStr: ' ' | titlecase} }}
                </h2>
                <div class="viator-logo title-box__title title-box__title--with-icon">
                    <img src="assets/svg/viator-logo.svg" alt="Viator logo">
                </div>
            </div>
            <p class="description-box">
                {{ 'VIATOR.LOOKING_FOR_SOME_THINGS' | translate: {location: name | replaceStr: ' ' | titlecase} }}
            </p>
        </div>

        <div class="location-info__content">
            <app-viator
                    [cityId]="id"
                    [cityName]="name"
                    [countryName]="countryName"
                    [categories]="viatorEvents"
                    [isFetching]="isFetching || !id"
                    (numOfHurt)="numOfHurt = $event"
            ></app-viator>
        </div>
        <div class="location-info__footer"></div>
    </section>
    <section class="location-info" [id]="getElementId(3)">
        <div class="location-info__header">
            <div class="title-box title-box--with-icon">
                <h2 class="title-box__title"
                    [innerHTML]="'OCCASION_GENIUS.EVENTS_AND_OCCASIONS' | translate: { location: name | replaceStr: ' ' | titlecase } | safeHtml"
                ></h2>
                <span class="viator-logo title-box__title title-box__title--with-icon"
                      [innerHTML]="'OCCASION_GENIUS.DONT_MISS_EVENTS_IN' | translate: { location: name | replaceStr: ' ' | titlecase } | safeHtml"
                ></span>
            </div>

            @if ((userStatus | async) === false) {
                <div class="btn-groups">
                    <button class="btn-default btn-sign-up" (click)="setAuth()">
                        Sign up to save your trip
                    </button>
                </div>
            }
        </div>
        <div class="location-info__content">
            <app-occasion-genius-with-filters
                    [isFetching]="isFetching || !id"
                    [events]="occasionGeniusResponse?.eventsSearchedAndSorted || []"
                    [occasionGeniusResponse]="occasionGeniusResponse"
                    [cityId]="id"
                    [cityName]="name"
                    [countryName]="countryName"
                    [startDate]="tripDates.startDate"
                    [endDate]="tripDates.endDate"
            ></app-occasion-genius-with-filters>
        </div>

        <div class="location-info__footer"></div>
    </section>
    <section class="location-info" [id]="getElementId(4)">
        <div class="location-info__header location-info__header--col">
            <div class="title-box title-box--action">
                <div class="title-box title-box--with-icon">
                    <h2 class="title-box__title">
                        {{ 'VOICE_MAP.CITY_VOICE_GUIDE_BY' | translate: {location: name | replaceStr: ' ' | titlecase} }}
                    </h2>
                    <div
                            class="viator-logo title-box__title title-box__title--with-icon">
                        <img class="voice-map-icon"
                             src="https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/images/voice-map.png?_a=ATFGlAA0"
                             loading="lazy" alt="voice-map">
                    </div>
                </div>

                @if ((userStatus | async) === false) {
                    <div class="btn-groups">
                        <button class="btn-default btn-sign-up" (click)="setAuth()">
                            Sign up to save your trip
                        </button>
                    </div>
                }
            </div>

            <div class="info-blue info-blue--voice-guide">
                <div class="info-blue__content">
                    <div class="info-blue__text">
                        RoutePerfect members get a <strong>free city voice guided</strong> tour for every hotel booked
                        through us
                    </div>
                </div>
            </div>
        </div>

        <div class="location-info__content">
            @if (audioTours.length) {
                <app-audio-tours
                        [itineraryItem]="audioTours"
                        [countryName]="countryName"
                        [cityName]="name"
                ></app-audio-tours>
            } @else {
                <app-no-items-found title="EMPTY.VOICE_MAP" subtitle=""></app-no-items-found>
            }
        </div>

        @if (stopovers.length) {
            <div class="location-info__footer"></div>
        }
    </section>
    @if (stopovers.length) {
        <section class="location-info" [id]="getElementId(5)">
            <div class="location-info__header location-info__header--col">
                <div class="title-box title-box--with-icon title-box--action">
                    <h2 class="title-box__title">
                        {{ 'STOPOVER.EN_ROUTE_TO' | translate: {startCity: startCityName, endCity: endCityName} }}
                    </h2>

                    @if ((userStatus | async) === false) {
                        <div class="btn-groups">
                            <button class="btn-default btn-sign-up" (click)="setAuth()">
                                Sign up to save your trip
                            </button>
                        </div>
                    }
                </div>

                @if (breakpointService.isDesktop()) {
                    <div class="info-blue info-blue--voice-guide">
                        <div class="info-blue__content">
                            <div class="info-blue__text">
                                RoutePerfect members enjoy unique ‘En-Route’ GPS based app. Discover sights and
                                attractions on your journey between cities
                            </div>
                        </div>
                    </div>
                }
            </div>

            <div class="location-info__content">
                <app-stopover-list
                        [stopovers]="stopovers"
                        [cityInfoIndex]="cityInfoIndex"
                        [destinations]="destinations"
                        [leg]="cityLeg"
                ></app-stopover-list>
            </div>
        </section>
    }
} @else {
    <div class="city-info">
        <div class="city-info__header">
            <div class="city-info__navigation">
                <button class="city-info__navigation--prev"
                        [disabled]="!destinations[cityInfoIndex - 1]"
                        (click)="onCityIndexChange.emit(cityInfoIndex - 1)">
                    <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_1"></mat-icon>
                    <span>{{ destinations[cityInfoIndex - 1]?.cityName }}</span>
                </button>

                <div class="city-info__navigation--info">
                    <div class="city-info__navigation--title">
                        {{ destinations[cityInfoIndex].cityName }}
                    </div>
                    <div class="city-info__navigation--count">
                        {{ destinations[cityInfoIndex].days }} nights
                    </div>
                </div>

                <button class="city-info__navigation--next"
                        [disabled]="!destinations[cityInfoIndex + 1]"
                        (click)="onCityIndexChange.emit(cityInfoIndex + 1)">
                    <span>{{ destinations[cityInfoIndex + 1]?.cityName }}</span>
                    <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_1"></mat-icon>
                </button>
            </div>

            <div class="city-info__anchor">
                <div class="swiper-container" appSwiper [swiperOptions]="anchorSwiperOptions">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <button class="tab-button" (click)="scrollToAnchor(0)">Info</button>
                        </div>
                        <div class="swiper-slide">
                            <button class="tab-button" (click)="scrollToAnchor(1)">Hotels</button>
                        </div>
                        <div class="swiper-slide">
                            <button class="tab-button" (click)="scrollToAnchor(2)">Landmarks & Activities</button>
                        </div>
                        <div class="swiper-slide">
                            <button class="tab-button" (click)="scrollToAnchor(3)">Events and Occasions</button>
                        </div>
                        <div class="swiper-slide">
                            <button class="tab-button" (click)="scrollToAnchor(4)">Voice Guide</button>
                        </div>
                        <div class="swiper-slide">
                            <button class="tab-button" (click)="scrollToAnchor(5)">En-Route</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="city-info__content">

            <section id="element-id-0">
                <div class="city-info__details">
                    <h1>About {{ name | replaceStr: ' ' | titlecase }}</h1>
                    <app-text-ellipsis
                            [short]="itineraryItem?.shortDescription"
                            [long]="itineraryItem?.description"
                            [extra]="itineraryItem?.extraDescription"
                            [isSmallText]="true"
                    ></app-text-ellipsis>
                </div>

                <app-gallery-mobile
                        [destinations]="attractions"
                ></app-gallery-mobile>
            </section>

            <section id="element-id-1">
                <app-hotels-booking-container
                        [showFilters]="false"
                        [itineraryIndex]="cityInfoIndex"
                        [city]="packages.length ? itineraryItem : null"
                        [country]="{id: null, countryName: countryName}"
                        [showInfoBlueLabel]="true"
                ></app-hotels-booking-container>
            </section>

            <section id="element-id-2">
                <app-viator
                        [cityId]="id"
                        [cityName]="name"
                        [countryName]="countryName"
                        [categories]="viatorEvents"
                        [isFetching]="!(viatorEvents | keyvalue)?.length"
                        (numOfHurt)="numOfHurt = $event"
                ></app-viator>
            </section>

            <section id="element-id-3">
                <app-occasion-genius
                        [cityId]="id"
                        [cityName]="name"
                        [countryName]="countryName"
                        [isFetching]="isFetching"
                        [occasionGeniusResponse]="occasionGeniusResponse"
                        [eventsSearchedAndSorted]="occasionGeniusResponse.eventsSearchedAndSorted"
                ></app-occasion-genius>
            </section>

            <section id="element-id-4">
                <app-audio-tours
                        [isFetching]="isFetching"
                        [itineraryItem]="audioTours"
                        [countryName]="countryName"
                        [cityName]="name"
                ></app-audio-tours>
            </section>

            <section class="location-info" id="element-id-5">
                <div class="location-info__header location-info__header--col">
                    @if (breakpointService.isDesktop()) {
                        <div class="title-box title-box--with-icon title-box--action">
                            <h2 class="title-box__title">
                                @if (breakpointService.isDesktop()) {
                                    {{
                                        'STOPOVER.EN_ROUTE_TO' | translate: {
                                            startCity: startCityName,
                                            endCity: endCityName
                                        }
                                    }}
                                } @else {
                                    En-Route.
                                }
                            </h2>

                            @if ((userStatus | async) === false) {
                                <div class="btn-groups">
                                    <button class="btn-default btn-sign-up" (click)="setAuth()">
                                        {{ 'AUTH.SIGN_IN.SIGN_UP' | translate }}
                                    </button>
                                </div>
                            }
                        </div>

                        @if ((userStatus | async) === false) {
                            <p class="description-box-blue" (click)="setAuth()">
                                {{ 'STOPOVER.PLEASE_SIGN_UP' | translate }}
                            </p>
                        }
                    } @else {
                        <h2>En-Route. </h2>

                        @if ((userStatus | async) === false) {
                            <button class="btn-default btn-green location-info__header--sign-in" (click)="setAuth()">
                                Sign up
                            </button>
                        }
                    }
                </div>

                <div class="location-info__content">
                    @if (breakpointService.isMobile()) {
                        <div class="location-info__content--title">
                            Explore sites & attractions on your way.
                        </div>
                        <div class="location-info__content--description">
                            As a member, you can find these points of interest along your way in Routperfects’
                            GPS-supported app
                        </div>
                    }

                    <app-stopover-list
                            [stopovers]="stopovers"
                            [cityInfoIndex]="cityInfoIndex"
                            [destinations]="destinations"
                            [leg]="cityLeg"
                    ></app-stopover-list>
                </div>
            </section>
        </div>
    </div>
}
